import { MenuItem, MenuList, Paper } from '@mui/material';
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux';
import ContextMenu from '../ContextMenu/ContextMenu';
import CopyAndPasteXML from './ContextActions/CopyAndPasteXML';
import Delete from './ContextActions/Delete';
import NewAttribute from './ContextActions/NewAttribute';
import NewComment from './ContextActions/NewComment';
import NewElement from './ContextActions/NewElement';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import CopyAndPaste from './ContextActions/CopyAndPaste';

const MODALS = {
    MNU_NEW_ATTR: 'MNU_NEW_ATTR',
    MNU_NEW_ELEM: 'MNU_NEW_ELEM',
    DELETE: 'DELETE',
    MNU_COPIED: 'MNU_COPIED',
    MNU_NEW_COMMENT: 'MNU_NEW_COMMENT'
}

function XMLMenu(props) {
    const { t } = useTranslation();
    const [modal, openModal] = useState(null);
    // const [isCopied, setIsCopied] = useState({ copy: false, paste: false });
    const [isDisable, setIsDisable] = useState(false);
    const parentScreen = useContext(ParentScreenCtx);
    const { tree, currentTab } = useSelector((state) => state.treeData[parentScreen].rightTree);
    const type = useSelector((state) => state.treeData[parentScreen].leftTree.tree.body.selectedNode?.type);
    const templateHeader = tree.templateHeader;
    const selectedKeysArray = tree[currentTab].selectedKeysArray;
    const {isCopied,setIsCopied} = props;

    const handleClick = (contextItem) => openModal(contextItem);

    const showMenu = useMemo(() => {
        const isTemplateEmpty =
            currentTab === "body"
                ? tree[currentTab]?.translatedData[0]?.children?.length !== 0 &&
                tree[currentTab]?.selectedNode?.ICON_DISPLAY !== "TEMPLATE_BODY_DOTS"
                : tree[currentTab]?.translatedData?.length !== 0;

        //Checking if node is Selected or not.
        const nodeSelected = Object.keys(tree?.[currentTab]?.selectedNode)?.length > 0;
        return isTemplateEmpty && nodeSelected;
    }, [tree[currentTab]?.translatedData,tree[currentTab].selectedNode]);

    const checkDisable = () => {
        return selectedKeysArray.includes("ib-0") && currentTab === "body"
    }

    useEffect(() => {
        setIsDisable(checkDisable());
    }, [selectedKeysArray])

    return (
        <>
            {
                ["inboundTemplate", "outboundTemplate", "workflow"].includes(type) &&
                showMenu &&
                !Array.isArray(templateHeader) && (
                    <ContextMenu targetId="rightTree">
                        <Paper elevation={3} sx={{ width: "19rem" }}>
                            <MenuList>
                                <MenuItem name={t("MNU_NEW_ELEM")} onClick={() => handleClick(MODALS.MNU_NEW_ELEM)}>
                                    <span className={"ELEMENT"}></span>
                                    <span className={"margin-left-8"}>{t("MNU_NEW_ELEM")}</span>
                                </MenuItem>
                                <MenuItem name={t("MNU_NEW_ATTR")} onClick={() => handleClick(MODALS.MNU_NEW_ATTR)}>
                                    <span className={"ATTRIBUTE"}></span>
                                    <span className={"margin-left-8"}>{t("MNU_NEW_ATTR")}</span>
                                </MenuItem>
                                <MenuItem name={t("MNU_USE_COMMENT")} onClick={() => handleClick(MODALS.MNU_NEW_COMMENT)}>
                                    <span className={"COMMENT"}></span>
                                    <span className={"margin-left-8"}>{t("MNU_USE_COMMENT")}</span>
                                </MenuItem>
                                <MenuItem disabled={isDisable} name={t("DELETE")} onClick={() => handleClick(MODALS.DELETE)}>
                                    <span className={"SYMBOL_DELETE"}></span>
                                    <span className={"margin-left-8"}>{t("DELETE")}</span>
                                </MenuItem>
                                <MenuItem disabled={isDisable} name={t("MNU_COPY")} onClick={() => setIsCopied({ paste: false, copy: true,dispatchFrom:'XMLMenu',treeType:""  })}>
                                    <span className={"COPY"}></span>
                                    <span className={"margin-left-8"}>{t("MNU_COPY")}</span>
                                </MenuItem>
                                {isCopied?.copiedNodes?.length ? <MenuItem name={t("MNU_PASTE")} onClick={() => setIsCopied({ ...isCopied, paste: true ,dispatchFrom:'XMLMenu',treeType:parentScreen })}>
                                    <span className={"DOCUMENT"}></span>
                                    <span className={"margin-left-8"}>{t("MNU_PASTE")}</span>
                                </MenuItem> : ''}
                            </MenuList>
                        </Paper>
                    </ContextMenu>
                )
            }
            <NewElement openModal={modal === MODALS.MNU_NEW_ELEM} toggle={() => handleClick(null)}/>
            <NewAttribute openModal={modal === MODALS.MNU_NEW_ATTR} toggle={() => handleClick(null)} />
            <NewComment openModal={modal === MODALS.MNU_NEW_COMMENT} toggle={() => handleClick(null)} />
            <Delete openModal={modal === MODALS.DELETE} toggle={() => handleClick(null)}/>
            <CopyAndPaste isCopied={isCopied} setIsCopied={setIsCopied} contextMenuType={isCopied?.dispatchFrom === "keyPress" ? isCopied?.dispatchFrom : "XMLMenu"} treeType={parentScreen}/>

        </>
    )
}

export default XMLMenu